'use strict';

/**
 * CompositeView for showing the review of import objects
 *
 * @category   View
 * @module     import
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var ColidoItemView = require('base/Colido.ItemView');

var template = require('../../templates/partials/review-list.hbs');

var ReviewListView = ColidoItemView.extend({
    template: template,

    /**
     * Options to pass to childView
     * @param [object} model The model
     * @param {int}    index The index of the model
     * @returns {object} The child view options
     */
    childViewOptions: function(model, index) {
        return {
            filteredCollection: this.filteredCollection,
        };
    },

    initialize: function(options) {
        ColidoItemView.prototype.initialize.apply(this, arguments);

        this.filteredCollection = this.collection.getFilteredCollection(function(model) {
            return model.hasColumnSelected();
        });

        this.listenTo(this.collection, 'add remove change reset', this.render);
    },
});

module.exports = ReviewListView;